import { Box } from '@mui/material'
import React from 'react'
import Navbar from '../Navbar'
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useLocation, Link } from 'react-router-dom';
import Footer from '../Footer';

const transValue = (trans) => {
  return (Number(trans.price) * Number(trans.amount)).toFixed(5)
}
const getBLockNumber = (id) => {
  return parseInt(id) + 6000000
}

export default function Transaction() {
  const location = useLocation()
  const transactionIdData = location.state;

  if (!transactionIdData) {
    return (
      <Box>
        <Navbar />
        <section className="term-detail-page">
          <div className="container">
            <div className="term-detail-empty">▸ NO TRANSACTION DATA</div>
          </div>
        </section>
        <Footer />
      </Box>
    )
  }

  return (
    <Box>
      <Navbar />
      <section className="term-detail-page">
        <div className="container">

          {/* Header */}
          <div className="term-detail-header">
            <div className="term-detail-crumb">
              <Link to="/">HOME</Link>
              <span>/</span>
              <span>TRANSACTIONS</span>
              <span>/</span>
              <span className="term-detail-crumb-active">{transactionIdData?.hash?.slice(0, 12)}…</span>
            </div>
            <div className="term-detail-title-row">
              <h1 className="term-detail-title">▸ TRANSACTION DETAILS</h1>
              <span className="term-status">
                <span className="term-dot"></span>SUCCESS
              </span>
            </div>
          </div>

          {/* Summary cards */}
          <div className="term-detail-summary">
            <div className="term-summary-card">
              <div className="term-summary-lbl">VALUE</div>
              <div className="term-summary-val term-summary-amber">${transValue(transactionIdData)}</div>
            </div>
            <div className="term-summary-card">
              <div className="term-summary-lbl">BLOCK</div>
              <div className="term-summary-val">{getBLockNumber(transactionIdData.block)}</div>
            </div>
            <div className="term-summary-card">
              <div className="term-summary-lbl">TYPE</div>
              <div className="term-summary-val">{transactionIdData.trans_type === "default" ? "Transfer" : "Swap"}</div>
            </div>
            <div className="term-summary-card">
              <div className="term-summary-lbl">SYMBOL</div>
              <div className="term-summary-val">
                {transactionIdData?.origin?.toLowerCase() === "hootdex" ? transactionIdData.symbol : "PECU"}
              </div>
            </div>
          </div>

          {/* Detail panel */}
          <div className="term-detail-panel">
            <div className="term-detail-panel-head">
              <span className="term-panel-title">▸ TRANSACTION DATA</span>
            </div>

            <div className="term-detail-rows">

              <div className="term-detail-row">
                <div className="term-detail-lbl">Transaction Hash</div>
                <div className="term-detail-val term-addr">{transactionIdData?.hash}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Status</div>
                <div className="term-detail-val">
                  <span className="successButton">
                    <i><CheckCircleIcon /></i>
                    Success
                  </span>
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">From</div>
                <div className="term-detail-val term-addr">{transactionIdData?.sender}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">To</div>
                <div className="term-detail-val term-addr">{transactionIdData?.recipient}</div>
              </div>

              <div className="term-detail-divider" />

              <div className="term-detail-row">
                <div className="term-detail-lbl">Block Height</div>
                <div className="term-detail-val">{getBLockNumber(transactionIdData.block)}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Block Size</div>
                <div className="term-detail-val">128 bytes</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Timestamp</div>
                <div className="term-detail-val">
                  <i><AccessTimeIcon sx={{ fontSize: 14, mr: 0.5 }} /></i>
                  {new Date(transactionIdData?.timestamp).toUTCString()}
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Node</div>
                <div className="term-detail-val">{transactionIdData.node}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Route</div>
                <div className="term-detail-val">{transactionIdData?.route}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Value</div>
                <div className="term-detail-val term-amount">{transValue(transactionIdData)} USD</div>
              </div>

              <div className="term-detail-divider" />

              <div className="term-detail-row">
                <div className="term-detail-lbl">Trans Type</div>
                <div className="term-detail-val">
                  {transactionIdData.trans_type === "default" ? "Transfer" : "Swap"}
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Origination</div>
                <div className="term-detail-val">
                  {transactionIdData.trans_type === "default" ? "PecuNovus Terminal" : "HootDex"}
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Symbol</div>
                <div className="term-detail-val">
                  {transactionIdData?.origin?.toLowerCase() === "hootdex"
                    ? <a href={`https://app.hootdex.net/${transactionIdData.symbol}`} target="_blank" rel="noreferrer" className="term-link">{transactionIdData.symbol}</a>
                    : "PECU"}
                </div>
              </div>

              <div className="term-detail-divider" />

              <div className="term-detail-row">
                <div className="term-detail-lbl">Block Address</div>
                <div className="term-detail-val term-addr">{transactionIdData?.key}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Contract Key</div>
                <div className="term-detail-val term-addr">{transactionIdData.contractKey}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Public Notes</div>
                <div className="term-detail-val">{transactionIdData?.publicNote || <span className="term-detail-empty-inline">—</span>}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Private Notes</div>
                <div className="term-detail-val">{transactionIdData?.privateNote || <span className="term-detail-empty-inline">—</span>}</div>
              </div>

            </div>
          </div>

        </div>
      </section>
      <Footer />
    </Box>
  )
}